/** Generate a fresh Collection id. */
export function createCollectionId(): string {
  return `coll_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 6)}`;
}
